// src/pages/landing/EtInvestors.jsx

import React from "react";
import EtHeader from "@/components/navigation/EtHeader";
import EtFooter from "@/components/navigation/EtFooter";

// Investor-specific sections (to be created)
import EtInvestorsHero from "@/components/sections/investors/EtInvestorsHero";
import EtInvestorsVision from "@/components/sections/investors/EtInvestorsVision";
import EtInvestorsTraction from "@/components/sections/investors/EtInvestorsTraction";
import EtInvestorsPitch from "@/components/sections/investors/EtInvestorsPitch";
import EtInvestorsCTA from "@/components/sections/investors/EtInvestorsCTA";

// 20 Nov 2025
import {useState, useEffect} from "react"

const EtInvestors = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Updated - 20 Nov 2025 - scroll control

 // 1 - Scroll to top on reload - 20 Nov 2025
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 100); 
        }
      }
    }
  }, []);

  return (
    <div className="font-poppins">
      {/* Global Header */}
      <EtHeader variant="investors" />

      {/* Page Sections */}
      <EtInvestorsHero />
      <EtInvestorsVision />
      {/* <EtInvestorsTraction /> */}
      {/* <EtInvestorsPitch /> */}
      <EtInvestorsCTA />

      {/* Global Footer */}
      <EtFooter variant="eternity"/>
    </div>
  );
};

export default EtInvestors;